import React, { useState, useContext, useRef } from 'react'
import { strCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import {
  flexGridRenderer,
  FlexCell,
  defaultFlexCellRenderer,
  Grid,
} from '@integec/grid-tools'
import { downloadFile, flexHeaderRender, exportDataComponent } from 'core/utils'
import { getApiTargetInfo, ExportComponent } from 'core'
import { connect } from 'react-redux'
import { getPiLog } from 'api/pgads.js'
import moment from 'moment'
// eslint-disable-next-line no-unused-vars
import { DatePicker, Input, Button, Table, message, Modal } from 'antd'
import {
  FullHeightSizer,
  Content,
  CriteriaRow,
  Filler,
  Title,
} from 'core/screen-util'
import querystring from 'querystring'
import { ErrorContext, SpinContext } from 'context'

const onBlob = (ident, id, apiTargetInfo, label) =>
  downloadFile(apiTargetInfo)(
    `pi/download-pilog-blob?${querystring.stringify({ id, ident })}`
  )(label + '-' + id + '.txt')

// eslint-disable-next-line no-unused-vars
const YNRender = (text, record, index) =>
  text === 'Y' || text === 'y' ? 'Yes' : 'No'

const BlobRender = (ident, label, apiTargetInfo) => (text, record) =>
  text === 'Y' || text === 'y' ? (
    <div onClick={_ => onBlob(ident, record.id, apiTargetInfo, label)}>
      View {label}
    </div>
  ) : (
    <div>No {label}</div>
  )
const headers = apiTargetInfo => [
  dateTimeCol({
    ident: 'reqTime',
    display: 'Request Time',
    width: 160,
    // dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
    // displayFormat: 'MM/DD/YYYY HH:mm:SS',
    isFiltered: true,
    render: text => moment(text).format('MM/DD/YYYY HH:mm:ss'),
  }),
  dateTimeCol({
    ident: 'resTime',
    display: 'Response Time',
    width: 160,
    // dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
    // displayFormat: 'MM/DD/YYYY HH:mm:SS',
    isFiltered: true,
    render: text => moment(text).format('MM/DD/YYYY HH:mm:ss'),
  }),
  strCol({
    ident: 'sucess',
    display: 'Success',
    width: 100,
    isFiltered: true,
    render: YNRender,
  }),
  strCol({
    ident: 'request',
    display: 'Request ',
    blob: true,
    width: 110,
    render: BlobRender('request', 'Request', apiTargetInfo),
  }),
  strCol({
    ident: 'response',
    display: 'Response ',
    blob: true,
    width: 110,
    render: BlobRender('response', 'Response', apiTargetInfo),
  }),
  strCol({
    ident: 'err',
    display: 'Error ',
    blob: true,
    width: 110,
    render: BlobRender('err', 'Error', apiTargetInfo),
  }),
  strCol({
    ident: 'userId',
    display: 'User Id ',
  }),
  strCol({
    ident: 'schedulerName',
    display: 'Scheduler Name',
  }),
  strCol({
    ident: 'tagName',
    display: 'Tag Name',
    width: 200,
    longString: true,
    isFiltered: true,
  }),
  strCol({
    ident: 'missingDataPitag',
    display: 'Missing Pi Tag',
    width: 200,
    longString: true,
    isFiltered: true,
  }),
]

// const antdHeader = apiTargetInfo =>
//   headers(apiTargetInfo).map(h => ({
//     ...h,
//     title: h.display,
//     dataIndex: h.ident,
//     ellipsis: true,
//   }))

const PiLog = props => {
  const { apiTargetInfo } = props
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [selectedDate, setSelectedDate] = useState(moment())
  const [data, setData] = useState([])
  const retrieveTask = _ => {
    setSpinning(true)
    getPiLog(props.apiTargetInfo)(selectedDate).fork(setError, data => {
      setSpinning(false)
      setData(data)
    })
  }

  const setGenMod = (display, val) =>
    Modal.info({
      title: display,
      content: (
        <div style={{ maxHeight: '400px', height: '400px', overflowY: 'auto' }}>
          {val}
        </div>
      ),
      onOk() {},
    })

  const redOn3X3Renderer = props => {
    const {
      rowIndex,
      width,
      height,
      data,
      header,
      apiTargetInfo,
      setGenMod,
    } = props

    if (header.ident === 'sucess') {
      return (
        <FlexCell width={width} height={height}>
          {data[rowIndex][header.ident].toLowerCase() === 'y' ? 'Yes' : 'No'}
        </FlexCell>
      )
    }

    if (header.blob === true) {
      const hd = 'View ' + header.display

      if (data[rowIndex][header.ident].toLowerCase() === 'n') {
        return (
          <FlexCell
            fontSize=".8em"
            fontWeight="bold"
            width={width}
            height={height}
          >
            No Error
          </FlexCell>
        )
      }

      return (
        <FlexCell
          color="red"
          fontSize=".8em"
          fontWeight="bold"
          width={width}
          height={height}
        >
          <Button
            style={{ width }}
            type="primary"
            onClick={() => {
              onBlob(
                header.ident,
                data[rowIndex].id,
                apiTargetInfo,
                header.display
              )
            }}
          >
            {/* {header.display} */}
            {hd}
          </Button>
        </FlexCell>
      )
    }
    if (header.longString) {
      let v = data[rowIndex][header.ident]

      if (v) {
        // v = v.replace(']', '').replace('[', '')
        v = v.length > 30 ? v.substring(0, 30) + '...' : v
      }
      return (
        <FlexCell
          fontSize=".8em"
          fontWeight="bold"
          width={width}
          height={height}
        >
          <div
            title={data[rowIndex][header.ident]}
            style={{ width: 'inherit' }}
            onClick={() => {
              setGenMod(header.display, data[rowIndex][header.ident])
            }}
          >
            {v}
          </div>
        </FlexCell>
      )
    }

    return defaultFlexCellRenderer(props)
  }

  const gridRender = (apiTargetInfo, heightOffSet, widthOffSet, setGenMod) =>
    flexGridRenderer({
      width: widthOffSet,
      height: heightOffSet,
      autoFixColByKey: true,
      colHeaderRenderer: flexHeaderRender,
      headerRowHeight: 30,
      cellRenderer: props =>
        redOn3X3Renderer({ ...props, apiTargetInfo, setGenMod }),
    })

  const GridRef = useRef()

  return (
    <div>
      <CriteriaRow>
        <Title>PI Log</Title>
        <DatePicker
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
          allowClear={false}
          style={{ marginLeft: '50px' }}
        />
        <Button
          style={{ marginLeft: '20px' }}
          primary
          onClick={retrieveTask}
          data-testid="criteria-retrieve"
          type="primary"
        >
          Retrieve
        </Button>
        <Filler />
        <Input
          style={{ marginLeft: '20px', maxWidth: '150px' }}
          data-testid="criteria-filter-input"
          value={fuzzyFilter}
          onChange={e => setFuzzyFilter(e.target.value)}
          icon="filter"
          placeholder="Filter"
        />
        <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          btnStyle={{ marginLeft: '20px' }}
          headers={headers(apiTargetInfo)}
          data={data}
          fileName="Export"
          data-testid="criteria-export"
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={200} widthOffSet={100}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            {/* <Table
                size="small"
                scroll={{ y: height - 100 }}
                pagination={false}
                columns={antdHeader(this.props.apiTargetInfo)}
                dataSource={this.state.data || []}
              /> */}
            <Grid
              ref={GridRef}
              sortEnabled
              data={data || []}
              headers={headers(apiTargetInfo)}
              // altBy={u => u.id}
              // altBgColor="#ebebeb"
              // onEditInfoChange={info => editRow(info)}
              // editInfo={editInfo}
              render={gridRender(
                apiTargetInfo,
                height - 60,
                width - 100,
                setGenMod
              )}
              fuzzyFilter={fuzzyFilter || ''}
              isEditable={false}
              selectionMode="single"
              selectionType="row"
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(PiLog)
